import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { DeviceFilter } from 'DiscoveryEngine.TS/Core';
import { ViewerDeviceFilterDto } from 'UvExplorerServer.Dtos.TS/Viewer';
import { Iterable } from 'DiscoveryEngine.TS/Utils';


 class DeviceFilterSelectorEntry {
	public dataKey: string;
	public name: string;
	public summary: string;

	public tag: ViewerDeviceFilterDto;
	public get hasDeviceFilterTag(): boolean {
		return !!this.tag;
	}

	constructor() {
		this.dataKey = "";
		this.name = "";
		this.summary = "";

		this.tag = null;
	}
}


@Component({
	selector: 'device-filter-selector',
	templateUrl: './device-filter-selector.component.html',
	styleUrls: ['./device-filter-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceFilterSelectorComponent implements OnInit, OnChanges {

	@Input()
	public header: string;

	@Input()
	public visible: boolean;

	@Input()
	public filters: Iterable<ViewerDeviceFilterDto>;

	@Input()
	public min: number;

	@Input()
	public max: number;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<ViewerDeviceFilterDto[]>

	@Output()
	public onCancel: EventEmitter<any>;

	public cols: any[];
	public entries: DeviceFilterSelectorEntry[];
	public selectedFilters: any;

	public doCustomSort(event): void {
		let comparer = function (a: DeviceFilterSelectorEntry, b: DeviceFilterSelectorEntry): number {
			let result = 0;

			switch (event.field) {
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	constructor(private changeDetector: ChangeDetectorRef) {

		this.header = "";
		this.visible = false;
		this.filters = null;
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<ViewerDeviceFilterDto[]>();
		this.onCancel = new EventEmitter<any>();
		this.cols = [
			{ field: 'name', header: 'Name', sortable: "custom", sortFunction: (event) => this.doCustomSort(event) },
			{ field: 'summary', header: 'Summary', sortable: "custom", sortFunction: (event) => this.doCustomSort(event) },
		];
		this.entries = [];

		this.clearSelectedFilters();
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	private clearSelectedFilters(): void {
		this.selectedFilters = (this.max == 1 ? undefined : []);
	}

	public ngOnInit(): void {
		this.rebuildEntries();
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		this.clearSelectedFilters();

		change = changes["filters"];
		if (change) {
			this.rebuildEntries();
		}
	}

	private rebuildEntries(): void {

		this.changeDetector.markForCheck();

		this.entries = [];

		if (this.filters) {
			this.filters.ForEach((filter: ViewerDeviceFilterDto) => {

				let entry = new DeviceFilterSelectorEntry();

				entry.dataKey = filter.DeviceFilter.GUID.toString();
				entry.tag = filter;
				entry.name = filter.DeviceFilter.Name;
				entry.summary = filter.DeviceFilter.Summary;

				this.entries.push(entry);
			}, this);
		}
	}

	public isOkEnabled(): boolean {
		if (this.max == 1) {
			return !!this.selectedFilters;
		}
		else {
			if (this.selectedFilters) {
				let len = this.selectedFilters.length;
				return (this.min <= len && len <= this.max);
			}
			return false;
		}
	}

	public onOkClicked(): void {	
		this.onOk.emit(this.getSelectedFilters());
		this.hide();
	}

	public onCancelClicked(): void {
		this.onCancel.emit();
		this.hide();
	}

	private getSelectedFilters(): ViewerDeviceFilterDto[] {
		let result: ViewerDeviceFilterDto[] = [];
		if (this.selectedFilters) {
			if (Array.isArray(this.selectedFilters)) {
				this.selectedFilters.forEach((entry: DeviceFilterSelectorEntry) => {
					result.push(entry.tag);
				}, this);
			}
			else {
				let entry = <DeviceFilterSelectorEntry>this.selectedFilters;
				result.push(entry.tag);
			}
		}
		return result;
	}

	public get totalFilterCount(): number {
		if (this.entries) {
			return this.entries.length;
		}
		else {
			return 0;
		}
	}

	public get selectedFilterCount(): number {
		if (this.selectedFilters) {
			if (Array.isArray(this.selectedFilters)) {
				return this.selectedFilters.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}
}
